import { render, staticRenderFns } from "./LatestUploads.vue?vue&type=template&id=8f522bf6&"
import script from "./LatestUploads.vue?vue&type=script&lang=js&"
export * from "./LatestUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTabs,QTab,QTabPanels,QTabPanel,QCardSection,QSpinnerPuff} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTabs,QTab,QTabPanels,QTabPanel,QCardSection,QSpinnerPuff})
